import React from 'react';
import styled from 'styled-components';

import EmbedModal, { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import { Button } from 'src/presentation/components/agent_desktop_components';

const ModalBody = ({ closeModalHandler, onSave, retentionDays }) => {
  return (
    <BodyWrapper>
      <p>
        If you proceed, your custom data retention settings will
        <br /> immediately take effect.
      </p>
      <p>
        All customer profiles with conversations marked as closed older than {retentionDays} days will be{' '}
        <b>permanently deleted</b>. This cannot be undone.
      </p>
      <div>
        <Button data-aid="data-retention-cancel" type={Button.Types.TEXT} onClick={closeModalHandler}>
          Cancel
        </Button>
        <Button data-aid="data-retention-modal-save" type={Button.Types.DANGER} onClick={onSave}>
          I understand, use custom settings
        </Button>
      </div>
    </BodyWrapper>
  );
};

export default function ConfirmationUseCustomConfigurationModal(props) {
  return (
    <StyledEmbedModal
      data-aid="data-retention-confirmation-modal"
      title="Use custom settings?"
      modalSize={ModalSize.DEFAULT}
      content={<ModalBody {...props} />}
      onCancel={props.closeModalHandler}
    />
  );
}

const BodyWrapper = styled.div`
  line-height: ${({ theme }) => theme.lineHeight.base};
`;

const StyledEmbedModal = styled(EmbedModal)`
  .modalCard-backdrop {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;
